import { render, staticRenderFns } from "./content-board-check.vue?vue&type=template&id=2ed92a56&"
import script from "./content-board-check.vue?vue&type=script&lang=js&"
export * from "./content-board-check.vue?vue&type=script&lang=js&"
import style0 from "./content-board-check.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-board-check.vue"
export default component.exports